import React from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import {
	FormGroup,
	FormControl,
	FormLabel,
	FormText,
	Col,
	Row,
} from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import DatePicker from "components/Shared/DatePicker";
import Switch from "components/Switch";
import SubmitButton from "components/SubmitButton";
import moment from "moment";
import {
	errorFormating,
	formatEmployeeSaveErrors,
	getAppName,
	isAdmin,
	isEmployeeCompanyFoundingAdmin,
} from "utils/utils";
import { convertFromUTC } from "utils/datetime";
import { validateSpanishID } from "utils/validation";

import { employeesService, shiftPatternsService } from "services";
import * as groupsActions from "actions/groupsActions";
import * as functionsActions from "actions/functionsActions";
import * as ubicationsActions from "actions/ubicationsActions";
import * as rulesActions from "actions/rulesActions";
import * as shiftsActions from "actions/shiftsActions";

import EmployeeContractForm from "./EmployeeContractForm";
import EmployeeGroupForm from "./EmployeeGroupForm";
import EmployeeFunctionForm from "./EmployeeFunctionForm";
import LocaleSelect from "components/Shared/LocaleSelect";

import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import i18next from "i18next";
registerLocale("es", es);

class EmployeeEdit extends React.Component {
	constructor(props) {
		super(props);

		const today = moment().format("YYYY-MM-DD");

		let employee_contract = {
			contract_id: 0,
			start_day: today,
			end_day: null,
		};

		let employee_group = {
			group_id: props.group_id ? props.group_id : -1,
			start_day: today,
			end_day: null,
		};

		let employee_function = {
			function_id: 0,
			priority: null,
			is_default: true,
			ubications: [],
		};

		let employee_ubication = {
			ubication_id: 0,
			skill: null,
			is_default: true,
		};

		let employee_shift_pattern = {
			shift_pattern_id: 0,
			start_day: today,
			end_day: null,
			start_index: 0,
		};

		const length_options = this.setLengthOptions(28);

		this.state = {
			step: 1,
			employee: {
				name: "",
				surname: "",
				email: "",
				nif: "",
				code: "",
				start_day: today,
				role: "EMPLOYEE",
				enabled: true,
				with_access: true,
			},
			isLoading: false,
			errors: {},
			employee_contract,
			employee_group,
			employee_function,
			employee_ubication,
			employee_shift_pattern,
			length_options,
			start_index_options: length_options,
		};
	}

	componentDidMount() {
		const {
			contracts,
			getContracts,
			groups,
			getAllGroups,
			select_functions,
			getSelectableFunctions,
			select_ubications,
			getSelectableUbications,
			select_shift_patterns,
			getSelectableShiftPatterns,
		} = this.props;

		if (!contracts || contracts.length === 0) {
			getContracts();
		}

		if (!groups || groups.length === 0) {
			getAllGroups();
		}

		if (!select_functions || select_functions.length === 0) {
			getSelectableFunctions();
		}

		if (!select_ubications || select_ubications.length === 0) {
			getSelectableUbications();
		}

		if (!select_shift_patterns || select_shift_patterns.length === 0) {
			getSelectableShiftPatterns();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.step !== this.state.step) {
			this.updateModalTitle();
		}
	}

	updateModalTitle = () => {
		const { step } = this.state;
		const { setModalTitle } = this.props;
		const titles = {
			1: i18next.t('newEmployee.stepEditTitle'),
			2: i18next.t('newEmployee.stepConfigureTitle'),
			3: i18next.t('newEmployee.stepContractTitle'),
			4: i18next.t('newEmployee.stepGroupTitle'),
			5: i18next.t('newEmployee.stepFunctionTitle'),
			6: i18next.t('newEmployee.stepUbicationTitle'),
			7: i18next.t('newEmployee.stepShiftPatternTitle'),
		};

		if (setModalTitle) {
			setModalTitle(titles[step] || i18next.t('newEmployee.stepEditTitle'));
		}
	};

	handleChange = (event, type) => {
		const { id, value } = event.target;
		var { length_options } = this.state;

		const targetEntity = type ? this.state[type] : this.state.employee;
		if (
			id === "email" &&
			isEmployeeCompanyFoundingAdmin(targetEntity, this.props.user?.company)
		) {
			return;
		}

		if (event.target.id == "shift_pattern_id") {
			this.getShiftPatternDetails(event.target.value);
		}

		this.setState((prevState) => ({
			length_options,
			[type || "employee"]: {
				...prevState[type || "employee"],
				[id]: value,
			},
		}));
	};

	handleBlur = (event) => {
		const { id, value } = event.target;
		if (id === "nif") {
			if (value && !validateSpanishID(value)) {
				this.setState((prevState) => ({
					errors: { ...prevState.errors, nif: i18next.t('newEmployee.errorNif') },
				}));
			} else {
				this.setState((prevState) => {
					const newErrors = { ...prevState.errors };
					delete newErrors.nif;
					return { errors: newErrors };
				});
			}
		}
	};

	getShiftPatternDetails = async (shift_pattern_id) => {
		if (shift_pattern_id < 0 || shift_pattern_id === "-1") {
			const length_options = this.setLengthOptions(28);
			this.setState({
				length_options,
				start_index_options: length_options,
				employee_shift_pattern: {
					...this.state.employee_shift_pattern,
					start_index: 0,
				},
			});
			return;
		}

		try {
			const response = await shiftPatternsService.getById(shift_pattern_id);

			if (response.ok) {
				const shift_pattern = response;
				const length = shift_pattern.length || 28;
				const length_options = this.setLengthOptions(
					length,
					shift_pattern.items || []
				);

				this.setState({
					length_options,
					start_index_options: length_options,
					employee_shift_pattern: {
						...this.state.employee_shift_pattern,
						start_index: 0,
					},
				});
			}
		} catch (error) {
			console.error("Error getting shift pattern details:", error);
			const length_options = this.setLengthOptions(28);
			this.setState({
				length_options,
				start_index_options: length_options,
				employee_shift_pattern: {
					...this.state.employee_shift_pattern,
					start_index: 0,
				},
			});
		}
	};

	handleDateChange = (id, date, type) => {
		const {
			employee,
			employee_contract,
			employee_group,
			employee_shift_pattern,
		} = this.state;

		if (!type && id === "start_day") {
			this.setState({
				employee: {
					...employee,
					[id]: date ? moment(date).format("YYYY-MM-DD") : "",
				},
				employee_contract: {
					...employee_contract,
					start_day: date ? moment(date).format("YYYY-MM-DD") : "",
				},
				employee_group: {
					...employee_group,
					start_day: date ? moment(date).format("YYYY-MM-DD") : "",
				},
				employee_shift_pattern: {
					...employee_shift_pattern,
					start_day: date ? moment(date).format("YYYY-MM-DD") : "",
				},
			});
		} else {
			this.setState((prevState) => ({
				[type || "employee"]: {
					...prevState[type || "employee"],
					[id]: date ? moment(date).format("YYYY-MM-DD") : "",
				},
			}));
		}
	};

	handleSwitch = (event) => {
		const { employee } = this.state;
		const { id, checked } = event.target;

		this.setState({
			employee: {
				...employee,
				[id]: checked,
			},
		});
	};

	checkValidField = (name) => {
		const { errors } = this.state;
		return !!errors[name];
	};

	setLengthOptions(limit, shiftPatternItems = []) {
		const length_options = [];

		for (var i = 0; i < limit; i++) {
			const shiftUbications =
				Array.isArray(shiftPatternItems) &&
				shiftPatternItems[i] &&
				Array.isArray(shiftPatternItems[i].shift_ubications)
					? shiftPatternItems[i].shift_ubications
					: [];
			const shiftsText = shiftUbications
				.filter((su) => su && su.shift)
				.map((su) => {
					const shift = su.shift;
					const intervals = Array.isArray(shift.time_intervals)
						? shift.time_intervals
								.map((ti) => {
									const start = convertFromUTC(ti.start);
									const end = convertFromUTC(ti.end);
									return start && end ? `${start}-${end}` : null;
								})
								.filter(Boolean)
						: [];
					return intervals.length > 0
						? `${shift.name} (${intervals.join(", ")})`
						: shift.name;
				})
				.join(" | ");
			const dayLabel = i18next.t('newEmployee.dayLabel', { n: i + 1 });
			length_options.push({
				index: i,
				label: shiftsText ? `${dayLabel} - ${shiftsText}` : dayLabel,
			});
		}

		return length_options;
	}

	getLengthFromShiftPattern(shift_pattern_id) {
		const { select_shift_patterns } = this.props;

		if (shift_pattern_id < 0) return 28;
		else {
			const shift_pattern = select_shift_patterns.find(
				(sp) => sp.id === parseInt(shift_pattern_id)
			);
			return shift_pattern.length;
		}
	}

	handleNext = async () => {
		const { step, employee } = this.state;
		const props = this.props;
		this.setState({ isLoading: true });

		try {
			if (step === 1) {
				if (employee.nif && !validateSpanishID(employee.nif)) {
					this.setState({
						errors: { nif: i18next.t('newEmployee.errorNif') },
						isLoading: false
					});
					return;
				}

				let response;

				const roles = [];
				roles.push(employee.role);

				const temp_employee = {
					...employee,
					roles,
				};

				if (employee.id) {
					response = await employeesService.update(temp_employee);
				} else {
					response = await employeesService.add(temp_employee);
				}

				if (response.ok) {
					toastr.success(i18next.t('common.success'), i18next.t('common.changesSaved'));
					this.setState(
						{
							step: step + 1,
							isLoading: false,
							employee: { ...employee, id: response.id },
						},
						() => {
							props.reloadEmployeeData?.();
						}
					);
				} else {
					const errors = formatEmployeeSaveErrors(response);
					const hasFieldError = Object.keys(errors).some(
						(key) => key !== "general" && !key.endsWith("_value")
					);
					if (errors.general && !hasFieldError) {
						toastr.error(i18next.t("common.error"), errors.general);
					}
					this.setState({
						isLoading: false,
						submitted: true,
						errors,
					});
				}
			} else if (step === 2) {
				this.setState({ step: step + 1, isLoading: false });
			} else if (step === 3) {
				// asignar contrato
			} else if (step === 4) {
				// asignar grupo
			} else if (step === 5) {
				// asignar función
			} else if (step === 6) {
				const { employee_ubication } = this.state;
				const response = await employeesService.addUbication(
					employee.id,
					employee_ubication
				);

				if (response.ok) {
					toastr.success(i18next.t('common.success'), i18next.t('newEmployee.ubicationAssigned'));
					this.setState({
						step: step + 1,
						isLoading: false,
					});
				} else {
					this.setState({
						isLoading: false,
						submitted: true,
						errors: errorFormating(response),
					});
				}
			} else if (step === 7) {
				const { employee_shift_pattern } = this.state;
				const response = await employeesService.addShiftPattern(
					employee.id,
					employee_shift_pattern
				);

				if (response.ok) {
					toastr.success(i18next.t('common.success'), i18next.t('newEmployee.shiftPatternAssigned'));
					this.setState(
						{
							isLoading: false,
						},
						() => {
							props.handleClose();
						}
					);
				} else {
					this.setState({
						isLoading: false,
						submitted: true,
						errors: errorFormating(response),
					});
				}
			}
		} catch (error) {
			console.log(error);
			toastr.error(i18next.t('common.error'), i18next.t('newEmployee.errorSave'));
			this.setState({ errors: error.errors || {}, isLoading: false });
		}
	};

	handleBack = () => {
		this.setState((prevState) => ({
			step: prevState.step - 1,
		}));
	};

	handleJump = () => {
		this.setState((prevState) => ({
			step: prevState.step + 1,
		}));
	};

	submitEmployeeContract = async (employee_contract) => {
		const { step, employee } = this.state;
		this.setState({ isLoading: true });
		const response = await employeesService.addContract(
			employee.id,
			employee_contract
		);

		if (response.ok) {
			toastr.success(i18next.t('common.success'), i18next.t('newEmployee.contractAssigned'));
			this.setState({
				step: step + 1,
				isLoading: false,
			});
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	submitEmployeeGroup = async (employee_group) => {
		const { step, employee } = this.state;
		this.setState({ isLoading: true });
		const response = await employeesService.addGroup(
			employee.id,
			employee_group
		);
		const props = this.props;

		if (response.ok) {
			toastr.success(i18next.t('common.success'), i18next.t('newEmployee.groupAssigned'));
			this.setState(
				{
					step: step + 1,
					isLoading: false,
				},
				() => {
					if (employee_group.group_id === props.group_id) {
						props.reloadGroupData?.();
					}
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	submitEmployeeFunction = async (employee_function) => {
		const { step, employee } = this.state;
		this.setState({ isLoading: true });
		const response = await employeesService.addFunction(
			employee.id,
			employee_function
		);

		if (response.ok) {
			toastr.success(i18next.t('common.success'), i18next.t('newEmployee.functionAssigned'));
			this.setState({
				step: step + 1,
				isLoading: false,
			});
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	renderStep = () => {
		const {
			step,
			employee,
			errors,
			employee_contract,
			employee_group,
			employee_function,
			employee_ubication,
			employee_shift_pattern,
			isLoading,
			start_index_options,
		} = this.state;
		const {
			contracts,
			groups,
			select_functions,
			select_ubications,
			select_shift_patterns,
		} = this.props;
		const hasAccess = employee.with_access;
		const appName = getAppName();
		const isFoundingAdminEmailLocked = isEmployeeCompanyFoundingAdmin(
			employee,
			this.props.user?.company
		);
		const optionUbicationList =
			select_ubications.length > 0 &&
			select_ubications.map((item, i) => (
				<option key={i} value={item.id}>
					{item.name}
				</option>
			));

		const optionShiftPatternList =
			select_shift_patterns.length > 0 &&
			select_shift_patterns.map((item, i) => (
				<option key={i} value={item.id}>
					{item.name}
				</option>
			));

		const optionIndexList = (start_index_options || []).map((item) => (
			<option key={item.index} value={item.index}>
				{item.label}
			</option>
		));
		const canSelectStartIndex =
			Number(employee_shift_pattern.shift_pattern_id) > 0;

		switch (step) {
			case 1:
				return (
					<form>
						{errors.general && (
							<div
								className="alert alert-danger alert-general-error fade show"
								role="alert"
							>
								{errors.general}
							</div>
						)}
						<FormGroup className="form-group" controlId="name">
							<FormLabel>
								{i18next.t('newEmployee.labelName')} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={employee.name}
								onChange={this.handleChange}
								placeholder={i18next.t('newEmployee.labelName')}
								isInvalid={this.checkValidField("name")}
							/>
							<FormControl.Feedback type="invalid">
								{errors.name}
							</FormControl.Feedback>
						</FormGroup>

						<FormGroup className="form-group" controlId="surname">
							<FormLabel>
								{i18next.t('newEmployee.labelSurname')} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={employee.surname}
								onChange={this.handleChange}
								placeholder={i18next.t('newEmployee.labelSurname')}
								isInvalid={this.checkValidField("surname")}
							/>
							<FormControl.Feedback type="invalid">
								{errors.surname}
							</FormControl.Feedback>
						</FormGroup>

						<Row>
							<Col md={6}>
								<FormGroup className="form-group" controlId="nif">
									<FormLabel>{i18next.t('newEmployee.labelNif')}</FormLabel>
									<FormControl
										type="text"
										value={employee.nif}
										onChange={this.handleChange}
										onBlur={this.handleBlur}
										placeholder={i18next.t('newEmployee.labelNif')}
										isInvalid={this.checkValidField("nif")}
									/>
									<FormControl.Feedback type="invalid">
										{errors.nif}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
							<Col md={6}>
								<FormGroup className="form-group" controlId="code">
									<FormLabel>{i18next.t('newEmployee.labelCode')}</FormLabel>
									<FormControl
										type="text"
										value={employee.code}
										onChange={this.handleChange}
										placeholder={i18next.t('newEmployee.labelCodePlaceholder')}
									/>
								</FormGroup>
							</Col>
						</Row>

						<FormGroup className="form-group" controlId="email">
							<FormLabel>
								{i18next.t('newEmployee.labelEmail')} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="email"
								value={employee.email}
								onChange={this.handleChange}
								placeholder="nombre@miempresa.com"
								isInvalid={this.checkValidField("email")}
								disabled={isFoundingAdminEmailLocked}
							/>
							<FormControl.Feedback type="invalid">
								{errors.email}
							</FormControl.Feedback>
							{isFoundingAdminEmailLocked && (
								<FormText muted>
									{i18next.t('newEmployee.emailLocked')}
								</FormText>
							)}
						</FormGroup>

						<Row>
							{isAdmin() && (
								<Col md={6}>
									<FormGroup className="form-group" controlId="role">
										<FormLabel>{i18next.t('newEmployee.labelRole')}</FormLabel>
										<FormControl
											as="select"
											value={employee.role}
											onChange={this.handleChange}
											isInvalid={this.checkValidField("role")}
										>
											<option value="EMPLOYEE">{i18next.t('newEmployee.roleEmployee')}</option>
											<option value="ADMIN">{i18next.t('newEmployee.roleAdmin')}</option>
										</FormControl>
										<FormControl.Feedback type="invalid">
											{errors.role}
										</FormControl.Feedback>
									</FormGroup>
								</Col>
							)}

							<Col md={6}>
								<FormGroup
									controlId="start_day"
									className={`form-group form-date ${employee.start_day === "" && "empty"}`}
								>
									<FormLabel>
										{i18next.t('newEmployee.labelHireDate')}{" "}
										<span className="label-required">*</span>
									</FormLabel>
									<DatePicker
										selected={
											employee.start_day
												? moment(employee.start_day).toDate()
												: null
										}
										onChange={(date) =>
											this.handleDateChange("start_day", date)
										}
										className="form-control"
										placeholderText="dd/mm/aaaa"
									/>
									<FiCalendar />
									<FormControl.Feedback type="invalid">
										{errors.start_day}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col md={6}>
								<FormGroup className="form-group" controlId="locale">
									<FormLabel>{i18next.t("employee.locale")}</FormLabel>
									<LocaleSelect
										value={employee.locale || "es"}
										onChange={(val) =>
											this.setState((prev) => ({
												employee: { ...prev.employee, locale: val },
											}))
										}
									/>
								</FormGroup>
							</Col>
						</Row>

						<FormGroup
							className="form-group form-group-flex"
							controlId="with_access"
						>
							<FormLabel className="label-normal">{i18next.t('newEmployee.labelAccess', { appName })}</FormLabel>
							<Switch
								controlId="with_access"
								isOn={hasAccess}
								handleToggle={this.handleSwitch}
							/>
						</FormGroup>
					</form>
				);
			case 2:
				return (
					<>
						<div className="alert alert-success mb30">
							<p className="mb0">{i18next.t('newEmployee.savedSuccess')}</p>
						</div>
						<p className="mb30">
							{i18next.t('newEmployee.configureHint')}
						</p>
					</>
				);
			case 3:
				return (
					<EmployeeContractForm
						initialEmployeeContract={employee_contract}
						contracts={contracts}
						errors={errors}
						handleSubmit={this.submitEmployeeContract}
						isLoading={isLoading}
						checkValidField={this.checkValidField}
						handleClose={this.handleBack}
						showFechaFin={false}
						cancelButtonText={i18next.t('common.back')}
						saveButtonText={i18next.t('newEmployee.stepContractTitle')}
					/>
				);
			case 4:
				return (
					<EmployeeGroupForm
						initialEmployeeGroup={employee_group}
						groups={groups}
						errors={errors}
						handleSubmit={this.submitEmployeeGroup}
						isLoading={isLoading}
						checkValidField={this.checkValidField}
						handleClose={this.handleJump}
						showFechaFin={false}
						cancelButtonText={i18next.t('employeeGroups.btnSkip')}
						saveButtonText={i18next.t('employeeGroups.assignGroup')}
					/>
				);
			case 5:
				return (
					<EmployeeFunctionForm
						initialEmployeeFunction={employee_function}
						functions={select_functions}
						errors={errors}
						handleSubmit={this.submitEmployeeFunction}
						isLoading={isLoading}
						checkValidField={this.checkValidField}
						handleClose={this.handleJump}
						showAdvanced={false}
						cancelButtonText={i18next.t('employeeGroups.btnSkip')}
						saveButtonText={i18next.t('newEmployee.stepFunctionTitle')}
					/>
				);
			case 6:
				return (
					<form>
						<FormGroup className="form-group" controlId="ubication_id">
							<FormLabel>{i18next.t('newEmployee.labelUbication')}</FormLabel>
							<FormControl
								onChange={(event) =>
									this.handleChange(event, "employee_ubication")
								}
								onBlur={this.handleBlur}
								value={employee_ubication.ubication_id}
								isInvalid={this.checkValidField("ubication_id")}
								as="select"
							>
								<option value="-1">{i18next.t('newEmployee.selectUbication')}</option>
								{optionUbicationList}
							</FormControl>

							<FormControl.Feedback type="invalid">
								{errors.ubication_id}
							</FormControl.Feedback>
						</FormGroup>
					</form>
				);
			case 7:
				return (
					<form>
						<FormGroup className="form-group" controlId="shift_pattern_id">
							<FormLabel>{i18next.t('newEmployee.labelShiftPattern')}</FormLabel>
							<FormControl
								onChange={(event) =>
									this.handleChange(event, "employee_shift_pattern")
								}
								value={employee_shift_pattern.shift_pattern_id}
								isInvalid={this.checkValidField("shift_pattern_id")}
								as="select"
							>
								<option value="-1">{i18next.t('newEmployee.selectShiftPattern')}</option>
								{optionShiftPatternList}
							</FormControl>

							<FormControl.Feedback type="invalid">
								{errors.shift_pattern_id}
							</FormControl.Feedback>
						</FormGroup>

						<FormGroup
							controlId="start_day"
							className={`form-group form-date ${employee_shift_pattern.start_day === "" && "empty"}  ${this.checkValidField("start_day") && "is-invalid"}`}
						>
							<FormLabel>{i18next.t('newEmployee.labelStartDate')}</FormLabel>
							<DatePicker
								selected={
									employee_shift_pattern.start_day === "" ||
										!employee_shift_pattern.start_day
										? employee_shift_pattern.start_day
										: moment(employee_shift_pattern.start_day).toDate()
								}
								onChange={(date) =>
									this.handleDateChange(
										"start_day",
										date,
										"employee_shift_pattern"
									)
								}
								isInvalid={this.checkValidField("start_day")}
								className="form-control"
								dateFormat="dd/MM/yyyy"
								locale="es"
								placeholderText="dd/mm/aaaa"
							/>
							<FiCalendar />
							<FormControl.Feedback type="invalid">
								{errors.start_day}
							</FormControl.Feedback>
						</FormGroup>

						<FormGroup className="form-group" controlId="start_index">
							<FormLabel>{i18next.t('newEmployee.labelStartIndex')}</FormLabel>
							<FormControl
								onChange={(event) =>
									this.handleChange(event, "employee_shift_pattern")
								}
								value={employee_shift_pattern.start_index}
								isInvalid={this.checkValidField("start_index")}
								as="select"
								disabled={!canSelectStartIndex}
							>
								{optionIndexList}
							</FormControl>

							<FormControl.Feedback type="invalid">
								{errors.start_index}
							</FormControl.Feedback>
						</FormGroup>
					</form>
				);
			default:
				return <div>{i18next.t('newEmployee.employeeReady')}</div>;
		}
	};

	render() {
		const { step, isLoading, employee } = this.state;
		let textButton;

		if (step === 1) {
			textButton = employee?.id
				? i18next.t('newEmployee.btnUpdate')
				: i18next.t('newEmployee.btnCreate');
		} else if (step === 2) {
			textButton = i18next.t('newEmployee.btnConfigure');
		} else if (step === 6) {
			textButton = i18next.t('newEmployee.stepUbicationTitle');
		} else if (step === 7) {
			textButton = i18next.t('newEmployee.stepShiftPatternTitle');
		} else {
			textButton = i18next.t('common.next');
		}

		return (
			<>
				<div className="modal-body">{this.renderStep()}</div>

				<div className="modal-footer">
					{step == 2 && (
						<button
							type="button"
							onClick={this.handleBack}
							className="btn btn-outline-primary"
						>
							{i18next.t('common.back')}
						</button>
					)}
					{step == 6 && (
						<button
							type="button"
							onClick={this.handleJump}
							className="btn btn-outline-primary"
						>
							{i18next.t('employeeGroups.btnSkip')}
						</button>
					)}
					{step == 7 && (
						<button
							type="button"
							onClick={this.props.handleClose}
							className="btn btn-outline-primary"
						>
							{i18next.t('common.close')}
						</button>
					)}
					{(step < 3 || step === 6 || step === 7) && (
						<>
							<SubmitButton
								type="button"
								isLoading={isLoading}
								onClick={this.handleNext}
								text={textButton}
								loadingText={i18next.t('common.saving')}
							/>
						</>
					)}
				</div>
			</>
		);
	}
}

const mapStateToProps = (reducers, myProps) => ({
	...reducers.employeesReducer,
	...reducers.groupsReducer,
	...reducers.functionsReducer,
	...reducers.ubicationsReducer,
	...reducers.rulesReducer,
	...reducers.shiftsReducer,
	employee: myProps.employee,
	user: reducers.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
	getContracts: () => dispatch(rulesActions.getContracts()),
	getAllGroups: () => dispatch(groupsActions.getAllGroups()),
	getSelectableFunctions: () =>
		dispatch(functionsActions.getSelectableFunctions()),
	getSelectableUbications: () =>
		dispatch(ubicationsActions.getSelectableUbications()),
	getSelectableShiftPatterns: () =>
		dispatch(shiftsActions.getSelectableShiftPatterns()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeEdit);
